import { Socket } from "socket.io-client";

export interface PhoneFeature {
  user: string;
  dndEnabled?: boolean;
  forwardBusyEnabled?: boolean;
  forwardNoAnswerEnabled?: boolean;
  forwardImmediateEnabled?: boolean;
}

interface CallbackResponse<T = any> {
  code: number;
  message: string;
  data?: T;
  error?: string;
}

export const getPhoneFeatures = (
  socket: Socket,
  callback: (phoneFeatures: PhoneFeature[]) => void
) => {
  try {
    if (!socket) return;

    socket.emit("get-phone-features", (res: CallbackResponse<PhoneFeature[]>) => {
      if (!res.data || !Array.isArray(res.data)) return;

      const phoneFeatures = res.data.map((feature) => ({
        user: feature.user,
        dndEnabled: feature.dndEnabled,
        forwardBusyEnabled: feature.forwardBusyEnabled,
        forwardNoAnswerEnabled: feature.forwardNoAnswerEnabled,
        forwardImmediateEnabled: feature.forwardImmediateEnabled,
      }));

      callback(phoneFeatures);
    });
  } catch (error) {
    console.error("Error getting phone features:", error);
  }
};

export const handlePhoneFeature = (
  payload: PhoneFeature,
  callback: (phoneFeature: PhoneFeature) => void
) => {
  try {
    if (!payload || typeof payload !== "object") {
      throw new Error("Invalid phone-feature payload");
    }

    const { user, dndEnabled, forwardBusyEnabled, forwardNoAnswerEnabled, forwardImmediateEnabled } = payload;

    if (!user) {
      throw new Error("Missing required field 'user' in phone-feature payload");
    }

    callback({
      user,
      dndEnabled,
      forwardBusyEnabled,
      forwardNoAnswerEnabled,
      forwardImmediateEnabled,
    });
  } catch (error) {
    console.error("Error handling phone-feature:", error);
  }
};

